import {
  keepPreviousData,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";

import {
  addOverhead,
  deleteOverhead,
  getOverheads,
  updateOverhead,
} from "../network/api/overheads.api";
import { OverheadFilters } from "../network/api/types.api";
import { OverheadInput } from "../types";

const useInvalidateOverheads = () => {
  const queryClient = useQueryClient();

  return () => {
    queryClient.invalidateQueries({ queryKey: ["overheads"] });
    queryClient.invalidateQueries({ queryKey: ["salesReport"] });
  };
};

export const useOverheads = (filters: OverheadFilters) =>
  useQuery({
    queryKey: ["overheads", filters],
    queryFn: () => getOverheads(filters),
    placeholderData: keepPreviousData,
    meta: {
      errorMessage: "Failed to load overheads. Please try again.",
    },
  });

export const useAddOverhead = () => {
  const invalidate = useInvalidateOverheads();

  return useMutation({
    mutationFn: (params: OverheadInput) => addOverhead(params),
    onSuccess: invalidate,
  });
};

export const useUpdateOverhead = () => {
  const invalidate = useInvalidateOverheads();

  return useMutation({
    mutationFn: (params: Partial<OverheadInput> & { id: string }) =>
      updateOverhead(params),
    onSuccess: invalidate,
  });
};

export const useDeleteOverhead = () => {
  const invalidate = useInvalidateOverheads();

  return useMutation({
    mutationFn: (id: string) => deleteOverhead(id),
    onSuccess: invalidate,
  });
};
